import OpenMobileApp from "../../../../modules/OpenMobileApp/OpenMobileApp";
import { connect } from "react-redux";
import { closeMobileSliderPageAction } from "../../../mobileAppActions";
import { useCallback } from "react";

function SlideMobileOpenMobileApp(props) {
    const {closeMobileSliderPage} = props;

    const handleClose = useCallback(() => {
        closeMobileSliderPage()
    }, [closeMobileSliderPage]);

    return <OpenMobileApp onClose={handleClose}/>
}

const mapDispatchToProps = (dispatch) => ({
    closeMobileSliderPage: payload => dispatch(closeMobileSliderPageAction(payload)),
});

export default connect(null, mapDispatchToProps)(SlideMobileOpenMobileApp);
